import { render } from "./challengeConfiguration.vue?vue&type=template&id=ae09312e&ts=true"
import script from "./challengeConfiguration.vue?vue&type=script&lang=ts"
export * from "./challengeConfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__